import request from 'Request'

const UsersService = {
  async get({ userId }) {
    return request.get('/users/get', { params: { userId } })
  },

  async list({ virtualOfficeId } = {}) {
    return request.post('/users/list', { virtualOfficeId })
  },

  async create({ firstName, lastName, username, permissionLevel }) {
    return request.put('/users/create', { firstName, lastName, username, permissionLevel })
  },

  async update({ userId, firstName, lastName, username, permissionLevel, password, archived }) {
    return request.patch('/users/update', {
      userId,
      firstName,
      lastName,
      username,
      permissionLevel,
      password,
      archived
    })
  },

  async addVirtualOffices({ userId, virtualOfficeIds }) {
    return request.put('/users/add-child', {
      userId,
      virtualOfficeIds
    })
  },

  async removeVirtualOffices({ userId, virtualOfficeIds }) {
    return request.delete('/users/remove-child', {
      data: {
        userId,
        virtualOfficeIds
      }
    })
  },

  async regenerateVerificationCode({ userId, removePassword }) {
    return request.delete('/users/remove-child', {
      userId,
      removePassword
    })
  },

  async getByOffice({ officeIds }) {
    return request.post('/users/get-by-office', { officeIds })
  }
}

export default UsersService
